export const CONTENT_TYPE_JSON = "application/json";
export const CONTENT_TYPE_JSON_API = "application/vnd.api+json";
